module.exports = __webpack_public_path__ + "img/body-blood-insulin.0661601.svg";